export default __webpack_public_path__ + "static/media/soundOne.bac94d19.wav";